module.exports = __webpack_public_path__ + "static/attach-videos-2-b4506f07a6aebf70f6f8e41361b30aa4.jpg";